module.exports = __webpack_public_path__ + "static/media/LINEAR.947a5e9b.svg";